<template>
  <div
    class="ai-visibility-step-intro"
    :class="{ 'ai-visibility-step-intro--flush': flush }"
  >
    <h3>{{ title }}</h3>
    <p v-if="description">{{ description }}</p>
    <p v-else-if="$slots.default">
      <slot />
    </p>
  </div>
</template>

<script>
export default {
  name: 'StepIntro',
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    flush: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-step-intro {
  h3 {
    color: var(--v-mainColor-base);
    font-size: 18px;
    font-weight: 800;
    margin: 0 0 16px;
  }

  p {
    color: var(--v-blackColor-base);
    font-size: 14px;
    line-height: 1.4;
    margin: 0 0 20px;
  }
}

.ai-visibility-step-intro--flush p {
  margin-bottom: 0;
}
</style>
